import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

import { withAuth } from 'hoc';

export const PrivateRoute = (props) => {
  const { component: Component, isAuthed, ...rest } = props;

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthed ? <Component {...props} /> : <Redirect to="/login" />
      }
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.any.isRequired,
  isAuthed: PropTypes.bool.isRequired,
};

export default withAuth(PrivateRoute);
